<template>
  <div class="w-full sm:min-w-[13.75rem] sm:max-w-[17.5rem]">
    <div class="sm:hidden flex justify-between items-center w-full">
      <div class="font-medium pl-2 sm:text-xl">{{ t('checkout.payment-method') }}</div>
      <div
        class="flex items-center h-11 px-4 py-2 rounded-lg bg-v-300 shadow-[0_2px_6px_0_rgba(0,0,0,0.35)] cursor-pointer transition-colors"
        @click="showDrawer = true"
      >
        <l-icon
          :name="CASH_METHODS.includes(model!.type) ? 'cash' : 'card'"
          size="large"
          class="mr-3"
        />
        {{ model!.name }}
      </div>
    </div>
    <component :is="isMobile ? Drawer : 'div'" v-model="showDrawer">
      <div class="flex flex-col w-full px-4 sm:p-0">
        <div class="font-medium pl-2 sm:text-xl py-4 text-xl">
          {{ t('checkout.payment-method') }}
        </div>
        <div class="flex flex-col gap-3 min-w-0 mb-4">
          <l-selectable-button
            v-for="method in paymentMethods"
            :key="method.name"
            size="large"
            :is-selected="model!.type === method.type"
            :icon="CASH_METHODS.includes(method.type) ? 'cash' : 'card'"
            @click="selectMethod(method)"
          >
            <span class="truncate">{{ method.name }}</span>
          </l-selectable-button>
        </div>
      </div>
    </component>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { LIcon } from '@last/core-ui/paprika'

import Drawer from '@/components/Drawer.vue'
import type { PaymentMethod } from '@/types'
import { isMobile } from '@/utils/isMobile'

import LSelectableButton from './LSelectableButton.vue'

type Props = {
  paymentMethods: PaymentMethod[]
}

defineProps<Props>()

const CASH_METHODS = ['cash', 'cashdro', 'cashlogy', 'cashguard', 'glory', 'cashkeeper']

const model = defineModel<PaymentMethod>()
const showDrawer = ref(false)

const { t } = useI18n()

function selectMethod(method: PaymentMethod) {
  model.value = method
  showDrawer.value = false
}
</script>
